import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icon-profile.svg'
import _imports_1 from '@/assets/icon-logout.svg'


const _hoisted_1 = { class: "jr-bg-primary jr-px-6 jr-py-2 jr-flex jr-items-center jr-justify-between" }
const _hoisted_2 = { class: "jr-flex jr-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "jr-flex jr-mr-7.5 jr-items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mr-2",
  src: _imports_0,
  alt: "profile"
}, null, -1)
const _hoisted_5 = { class: "jr-text-sm jr-font-normal jr-text-white" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "jr-text-white jr-px-2 jr-cursor-pointer",
  alt: "logout"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" ログアウト ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jr-fixed jr-top-0 jr-w-full jr-z-50 jr-bg-white jr-min-w-main jr-h-global-nav", { 'jr-opacity-0': _ctx.isCapturing }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "jr-inline-block jr-text-white jr-font-bold",
        href: "/",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onclickLogo && _ctx.onclickLogo(...args)))
      }, "SmartCityDashBoard Powered by Beacon Bank"),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isShowUsername)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.username), 1)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
          class: "jr-flex jr-items-center jr-text-white jr-float-right jr-align-middle jr-cursor-pointer jr-text-base jr-inline-block jr-align-top"
        }, _hoisted_8, 512), [
          [_vShow, !_ctx.isLogin && !_ctx.isPasswordReset && !_ctx.isForgetPassword]
        ])
      ])
    ])
  ], 2))
}